/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2025-12-10 09:36:54
 * @LastEditTime: 2026-05-11 10:52:12
 * @LastEditors: hexy 913752270@qq.com
 * @Description  : 超图算管控
 * @FilePath     : \icps_fb\src\api\internetSales\supplyManagement.js
 */
<template>
    <div class="pages_content table">
        <el-container>
            <el-header>
                <breaDcrumb />
            </el-header>
            <el-main style="display: flex">
                <div>
                    <el-collapse-transition>
                        <div v-show="showCardNav">
                            <div class="search">
                                <span style="display: inline-block;  margin-bottom: 10px">
                                    <span style="margin-right: 12px">工程名称</span>
                                    <el-input v-model="tableParam.engineeringName"
                                        style="width: 180px; min-width: 150px; max-width: 220px" clearable placeholder="请输入"
                                        @keyup.enter.native="gettableData()" />
                                </span>
                                <span style="display: inline-block; margin-left: 12px">
                                    <span style="margin-right: 12px">责任预算</span>
                                    <el-input v-model="tableParam.budgetPersonName"
                                        style="width: 100px; min-width: 100px; max-width: 120px" clearable placeholder="请输入"
                                        @keyup.enter.native="gettableData()" />
                                </span>
                                <span style="display: inline-block; margin-left: 12px">
                                    <span style="margin-right: 12px">状态</span>
                                    <el-select v-model="tableParam.nodeControlStatus" style="width: 150px" clearable>
                                        <el-option label="待风控" :value="0"></el-option>
                                        <el-option label="已风控" :value="1"></el-option>
                                        <el-option label="临时解控" :value="2"></el-option>
                                        <el-option label="完全解控" :value="3"></el-option>
                                    </el-select>
                                </span>
                                <span style="display: inline-block; margin-left: 12px">
                                  <span style="margin-right: 12px">审批状态</span>
                                  <el-select v-model="tableParam.approvalStatus" style="width: 150px" clearable>
                                    <el-option label="已确认" :value="1" />
                                    <el-option label="审批通过" :value="2" />
                                    <el-option label="审批中" :value="3" />
                                    <el-option label="审核失败" :value="4" />
                                    <el-option label="撤销" :value="5" />
                                  </el-select>
                                </span>
                                <el-button icon="el-icon-search" style="margin-left: 24px" size="medium" class="bottom_all"
                                    @click="(tableParam.page = 1), gettableData()">查 询</el-button>
                            </div>
                        </div>
                    </el-collapse-transition>
                    <div class="hr"></div>
                    <div class="card">
                        <div class="card_nav">
                            <div>
                            </div>
                            <div>
                                <el-link :underline="false" @click="load()">
                                    <span class="el-icon--left">
                                        <i class="iconfont iconicon_button_export1"></i>
                                    </span>
                                    导出
                                </el-link>
                            </div>
                        </div>
                        <div v-loading="tableLoading" class="card_info" :style="style">
                            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }"
                                border stripe style="width: 100%" :height="screenHeight - 425" :data="tableData"
                                tooltip-effect="dark">
                                <template v-for="(item, index2) in table">
                                    <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center"
                                        :width="item.width" :fixed="item.fixed">
                                        <template slot-scope="scope">
                                            <!-- 状态列 -->
                                            <span v-if="item.label == '状态'">
                                                <el-link v-if="scope.row.nodeControlStatus == 0" type="danger"
                                                    :underline="false"
                                                    @click="getSuperGraphHistory(scope.row)">待风控</el-link>
                                                <el-link v-if="scope.row.nodeControlStatus == 1" type="danger"
                                                    :underline="false"
                                                    @click="getSuperGraphHistory(scope.row)">已风控</el-link>
                                                <el-link v-if="scope.row.nodeControlStatus == 2" type="success"
                                                    :underline="false"
                                                    @click="getSuperGraphHistory(scope.row)">临时解控</el-link>
                                                <el-link v-if="scope.row.nodeControlStatus == 3" type="success"
                                                    :underline="false"
                                                    @click="getSuperGraphHistory(scope.row)">完全解控</el-link>
                                            </span>
                                            
                                            <!-- 审批状态列 -->
                                            <span v-else-if="item.label == '审批状态'">
                                                <span v-if="scope.row.approvalStatus == 0"></span>
                                                <span v-if="scope.row.approvalStatus == 1">已确认</span>
                                                <span v-if="scope.row.approvalStatus == 2">审核通过</span>
                                                <span v-if="scope.row.approvalStatus == 3">审批中</span>
                                                <span v-if="scope.row.approvalStatus == 4">审核失败</span>
                                                <span v-if="scope.row.approvalStatus == 5">撤销</span>
                                            </span>

                                            <!-- 浇筑方式列 (处理JSON字符串) -->
                                            <span v-else-if="item.label == '浇筑方式'">
                                                {{ formatPourMethod(scope.row.pourMethod) }}
                                            </span>

                                            <!-- 操作列 -->
                                            <span v-else-if="item.label == '操作'">
                                                <!-- 完全解控(3)不显示按钮，其他状态(0,1,2)显示申请解控 -->
                                                <el-link v-if="scope.row.nodeControlStatus !== 3"
                                                    type="danger" :underline="false"
                                                    @click="applyRemoveControl(scope.row)">申请解控</el-link>
                                            </span>

                                            <!-- 默认显示 -->
                                            <span v-else>{{ scope.row[item.prop] }}</span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                        </div>
                    </div>
                </div>
            </el-main>
            <div class="card_bottom">
                <div class="card_bottom_left">
                    <div class="top_page_totle">总共{{ total }}条</div>
                    <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize"
                        :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper"
                        :total="total" @size-change="sizeChange" @current-change="gettableData()"></el-pagination>
                </div>
                <div>
                    <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two"
                        @click="gettableData">刷新</el-button>
                </div>
            </div>

            <!-- 申请解控对话框 -->
            <el-dialog :visible.sync="removeControlDig" width="1140px" :close-on-click-modal="false">
                <span slot="title" class="dialog-title">申请解控</span>
                <el-descriptions :column="2" border class="descriptions" label-width="200">
                    <el-descriptions-item label="申请日期：" >{{ formData.createTime }}</el-descriptions-item>
                    <el-descriptions-item label="工程名称：">{{ formData.engineeringName }}</el-descriptions-item>
                    <el-descriptions-item label="计划ID：">{{ formData.planId }}</el-descriptions-item>
                    <el-descriptions-item label="浇筑部位：">{{formData.part}}</el-descriptions-item>
                    <el-descriptions-item label="浇筑方式：">{{ formatPourMethod(formData.pourMethod )}}</el-descriptions-item>
                    <el-descriptions-item label="浇筑时间：">{{ formData.pourTime }}</el-descriptions-item>
                    <el-descriptions-item label="产品名称：">{{ formData.productName }}</el-descriptions-item>
                    <el-descriptions-item label="交底类型：">{{ formData.discloseType }}</el-descriptions-item>
                    <el-descriptions-item label="责任预算：">{{ formData.budgetPersonName }}</el-descriptions-item>
                    <el-descriptions-item label="结算方式：">{{ formData.settleMethod }}</el-descriptions-item>
                    <el-descriptions-item label="图算量：">{{ formData.graphicVol }}</el-descriptions-item>
                    <el-descriptions-item label="管控量：">{{ formData.manageVol }}</el-descriptions-item>
                    <el-descriptions-item label="供应量：">{{ formData.supplyVol }}</el-descriptions-item>
                    <el-descriptions-item label="管控时间：">{{ formData.nodeControlTime }}</el-descriptions-item>
                    <el-descriptions-item label="是否完全解控：" labelClassName="redFont"
                        :span="formData.whetherReleaseControl == 0 ? 1 : 2">
                        <el-select v-model="formData.whetherReleaseControl" style="width: 150px" clearable @change="handleWhetherReleaseChange">
                            <el-option label="否" :value="0"></el-option>
                            <el-option label="是" :value="1"></el-option>
                        </el-select>
                    </el-descriptions-item>
                    <!-- 只有当选择“否”(0) 时才显示申请解控时间 -->
                    <el-descriptions-item v-if="formData.whetherReleaseControl == 0" label="申请解控时间："
                        labelClassName="redFont">
                        <el-date-picker v-model="formData.releaseControlTime" style="width: 150px;" type="date"
                            unlink-panels value-format="yyyy-MM-dd"></el-date-picker>
                    </el-descriptions-item>
                    <el-descriptions-item label="未及时处理原因说明：" labelClassName="redFont" contentClassName="textClass"
                        :span="2">
                        <el-input v-model="formData.remark" placeholder="请输入" type="textarea"
                            style="width: 430px;">
                        </el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="附件：" :span="2">
                        <FileComponent fileCode="settlementFile" :disabled="isLook" :files="files" @deleteFile="deleteFile"
                            @uplodeSuccess="uplodeSuccess" />
                    </el-descriptions-item>
                </el-descriptions>
                <span style="font-size: 18px;margin-top: 24px;">历史申请流程</span>
                <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                    style="width: 100%;margin-top: 12px;" tooltip-effect="dark" :data="removeControlTableData">
                    <el-table-column label="申请时间" align="center" prop="createTime" width="160"></el-table-column>
                    <el-table-column label="申请人" align="center" prop="createUserName" width="70"></el-table-column>
                    <el-table-column label="图算量" align="center" prop="graphicVol" width="auto"></el-table-column>
                    <el-table-column label="管控量" align="center" prop="manageVol" width="auto"></el-table-column>
                    <el-table-column label="管控时间" align="center" prop="nodeControlTime" width="100"></el-table-column>
                    <el-table-column label="是否完全解控" align="center" prop="whetherReleaseControl" width="90"></el-table-column>
                    <el-table-column label="申请解控时间" align="center" prop="newReleaseControlTime" width="160"></el-table-column>
                    <!-- <el-table-column label="申请解控时间" align="center" prop="releaseControlTime" width="160"></el-table-column> -->
                    <el-table-column label="流程完成时间" align="center" prop="updateTime" width="160"></el-table-column>
                    <el-table-column label="审批状态" align="center" prop="approvalStatus" width="160">
                        <template slot-scope="scope">
                            <span v-if="scope.row.approvalStatus == 0"></span>
                            <span v-if="scope.row.approvalStatus == 1">已确认</span>
                            <span v-if="scope.row.approvalStatus == 2">审核通过</span>
                            <span v-if="scope.row.approvalStatus == 3">审批中</span>
                            <span v-if="scope.row.approvalStatus == 4">审核失败</span>
                            <span v-if="scope.row.approvalStatus == 5">撤销</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="left" width="90">
                        <template slot-scope="scope">
                            <el-button size="mini" class="bottom_two" @click="lookDetail(scope.row)">
                                查看
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <span slot="footer" class="dialog-footer">
                    <el-button class="bottom_all_two" @click="removeControlDig = false">关 闭</el-button>
                    <el-button class="bottom_all" @click="saveRemoveControl">提 交</el-button>
                </span>
            </el-dialog>

            <!-- 历史记录明细对话框 -->
            <el-dialog :visible.sync="historyDetailDig" width="1080px" :close-on-click-modal="false">
                <span slot="title" class="dialog-title">申请解控详情</span>
                <el-descriptions :column="2" border class="descriptions" label-width="200">
                    <el-descriptions-item label="申请日期：" >{{ historyDetailForm.createTime }}</el-descriptions-item>
                    <el-descriptions-item label="工程名称：">{{ historyDetailForm.engineeringName }}</el-descriptions-item>
                    <el-descriptions-item label="计划ID：">{{ historyDetailForm.planId }}</el-descriptions-item>
                    <el-descriptions-item label="浇筑部位：">{{historyDetailForm.part}}</el-descriptions-item>
                    <el-descriptions-item label="浇筑方式：">{{ formatPourMethod(historyDetailForm.pourMethod )}}</el-descriptions-item>
                    <el-descriptions-item label="浇筑时间：">{{ historyDetailForm.pourTime }}</el-descriptions-item>
                    <el-descriptions-item label="产品名称：">{{ historyDetailForm.productName }}</el-descriptions-item>
                    <el-descriptions-item label="交底类型：">{{ historyDetailForm.discloseType }}</el-descriptions-item>
                    <el-descriptions-item label="责任预算：">{{ historyDetailForm.budgetPersonName }}</el-descriptions-item>
                    <el-descriptions-item label="结算方式：">{{ historyDetailForm.settleMethod }}</el-descriptions-item>
                    <el-descriptions-item label="图算量：">{{ historyDetailForm.graphicVol }}</el-descriptions-item>
                    <el-descriptions-item label="管控量：">{{ historyDetailForm.manageVol }}</el-descriptions-item>
                    <el-descriptions-item label="供应量：">{{ historyDetailForm.supplyVol }}</el-descriptions-item>
                    <el-descriptions-item label="管控时间：">{{ historyDetailForm.nodeControlTime }}</el-descriptions-item>
                    <el-descriptions-item label="是否完全解控：" labelClassName="redFont"
                        :span="historyDetailForm.whetherReleaseControl == 0 ? 1 : 2">
                        <el-select v-model="historyDetailForm.whetherReleaseControl" :disabled="true" style="width: 150px" clearable>
                            <el-option label="否" :value="0"></el-option>
                            <el-option label="是" :value="1"></el-option>
                        </el-select>
                    </el-descriptions-item>
                    <el-descriptions-item v-if="historyDetailForm.whetherReleaseControl == 0" label="申请解控时间："
                        labelClassName="redFont">
                        <el-date-picker v-model="historyDetailForm.releaseControlTime" :disabled="true" style="width: 150px;" type="date"
                            unlink-panels value-format="yyyy-MM-dd"></el-date-picker>
                    </el-descriptions-item>
                    <el-descriptions-item label="未及时处理原因说明：" labelClassName="redFont" contentClassName="textClass"
                        :span="2">
                        <el-input v-model="historyDetailForm.remark" :disabled="true" placeholder="请输入" type="textarea"
                            style="width: 430px;">
                        </el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="附件：" :span="2">
                        <FileComponent fileCode="settlementFile" :disabled="true" :files="files2"  />
                    </el-descriptions-item>
                </el-descriptions>
                <span style="font-size: 18px">领导审批参数</span>
                <el-descriptions :column="2" border class="descriptions" label-width="200" style="margin-bottom: 24px;">
                    <el-descriptions-item label="是否完全解控：" labelClassName="redFont">{{
                        historyDetailForm.newWhetherReleaseControl == 1 ? "是" : "否" }}
                    </el-descriptions-item>
                    <el-descriptions-item v-if="historyDetailForm.newWhetherReleaseControl == 0"  label="申请解控时间：" labelClassName="redFont">
                        {{ historyDetailForm.newReleaseControlTime }}
                    </el-descriptions-item>
                </el-descriptions>
                <FlowsNodeList :tableData="approveTableData" />
                <span slot="footer" class="dialog-footer">
                    <el-button class="bottom_all_two" @click="historyDetailDig = false">关 闭</el-button>
                </span>
            </el-dialog>

            <!-- 历史记录列表对话框 -->
            <el-dialog title="历史记录" :visible.sync="historyDig" width="1140px">
                <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                    style="width: 100%;margin-top: 12px;" tooltip-effect="dark" :data="removeControlTableData">
                    <el-table-column label="申请时间" align="center" prop="createTime" width="160"></el-table-column>
                    <el-table-column label="申请人" align="center" prop="createUserName" width="70"></el-table-column>
                    <el-table-column label="图算量" align="center" prop="graphicVol" width="auto"></el-table-column>
                    <el-table-column label="管控量" align="center" prop="manageVol" width="auto"></el-table-column>
                    <el-table-column label="管控时间" align="center" prop="nodeControlTime" width="100"></el-table-column>
                    <el-table-column label="是否完全解控" align="center" prop="newWhetherReleaseControl" width="90">
                        <template slot-scope="scope">
                            <span v-if="scope.row.newWhetherReleaseControl == 0">否</span>
                            <span v-if="scope.row.newWhetherReleaseControl == 1">是</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="申请解控时间" align="center" prop="newReleaseControlTime" width="160"></el-table-column>
                    <!-- <el-table-column label="申请解控时间" align="center" prop="releaseControlTime" width="160"></el-table-column> -->
                    <el-table-column label="流程完成时间" align="center" prop="approvalTime" width="160"></el-table-column>
                    <el-table-column label="审批状态" align="center" prop="approvalStatus" width="160">
                        <template slot-scope="scope">
                            <span v-if="scope.row.approvalStatus == 0"></span>
                            <span v-if="scope.row.approvalStatus == 1">已确认</span>
                            <span v-if="scope.row.approvalStatus == 2">审核通过</span>
                            <span v-if="scope.row.approvalStatus == 3">审批中</span>
                            <span v-if="scope.row.approvalStatus == 4">审核失败</span>
                            <span v-if="scope.row.approvalStatus == 5">撤销</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="left" width="90">
                        <template slot-scope="scope">
                            <el-button size="mini" class="bottom_two" @click="lookDetail(scope.row)">
                                查看
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <span slot="footer" class="dialog-footer">
                    <el-button class="bottom_all_two" @click="historyDig = false">关 闭</el-button>
                </span>
            </el-dialog>
            <LookFile :visible.sync="lookFileVisible" :config="lookFileConfig" />
        </el-container>
    </div>
</template>
  
<script>
import mixin from "@/mixins/ICPSmixin.js";
import { superGraphQuery,  querySuperGraphHistory, superGraphDownload as Download  } from "@/api/internetSales/supplyManagement.js";
import FileComponent from "@/views/platform/ICPS/internetSales/components/fileComponent";
import FlowsNodeList from '@/components/WorkFlow/flowsNodeList';
import { getNodeList } from '@/api/task/flows';
import { getUserInfo } from "@/utils/auth.js";
import LookFile from "@/components/File/LookFile";

export default {
    components: {
        FileComponent,
        FlowsNodeList,
        LookFile
    },
    mixins: [mixin],
    data() {
        return {
            table: [
                { label: "计划ID", prop: "planId", status: true, width: "180", fixed: "left" },
                { label: "工程名称", prop: "engineeringName", status: true, width: "280", fixed: "left" },
                { label: "部位", prop: "part", status: true, width: "220" },
                { label: "浇筑方式", prop: "pourMethod", status: true, width: "160" },
                { label: "浇筑时间", prop: "pourTime", status: true, width: "160" },
                { label: "产品名称", prop: "productName", status: true, width: "120" },
                { label: "交底类型", prop: "discloseType", status: true, width: "120" },
                { label: "责任预算", prop: "budgetPersonName", status: true, width: "120" },
                { label: "结算方式", prop: "settleMethod", status: true, width: "120" },
                { label: "图算量", prop: "graphicVol", status: true, width: "100" },
                { label: "管控量", prop: "manageVol", status: true, width: "100" },
                { label: "供应量", prop: "supplyVol", status: true, width: "100" },
                { label: "管控时间", prop: "nodeControlTime", status: true, width: "120" },
                { label: "状态", prop: "nodeControlStatus", status: true, width: "120" },
                { label: "审批状态", prop: "approvalStatus", status: true, width: "120" },
                { label: "审批时间", prop: "approvalTime", status: true, width: "150" },
                { label: "操作", prop: "", status: true, width: "120" } //固定宽度防止抖动
            ],
            DownloadURL: Download,
            tableData: [],
            pagesType: 0,
            tableParam: {
                page: 1,
                pageSize: 10,
                engineeringName: "",
                budgetPersonName: "",
                nodeControlStatus: "",
                approvalStatus: "",
            },
            formData: {
                overDrawId: '',
                engineeringId: '',
                engineeringName: '',
                businesName: '',
                collaborationUnitName: '',
                coordinationSubject: '',
                budgetPersonName: '',
                settleMethod: '',
                constructionProgress: '',
                discloseType: '',
                nodelType: '',
                nodeName: '',
                initialTime: '',
                nodeParam: '',
                nodeControlTime: '',
                whetherReleaseControl: '',
                releaseControlTime: '',
                attachment: '',
                remark: '',
                newReleaseControlTime:"",
                newWhetherReleaseControl:"",
            },
            historyDetailForm: {},
            files: [],
            files2: [],
            confirmFiles: [], // 保留以防其他地方引用，虽然确认弹窗已删
            isLook: false,
            removeControlDig: false,
            historyDetailDig: false,
            low: {},
            approveTableData: [],
            userRealName: "",
            removeControlTableData: [],
            historyDig: false,
            dataType: 1,
            lookFileVisible: false,
            lookFileConfig: { filePaths: "" },
        };
    },
    async created() {
        this.tableParam.budgetPersonName = await getUserInfo().userRealName;
        // alert(this.tableParam.budgetPersonName)
        this.gettableData(true);
    },
    methods: {
        // 格式化浇筑方式 JSON 字符串
        formatPourMethod(val) {
            if (!val) return '-';
            // 1. 如果是字符串，强制解析；否则直接使用
            const data = typeof val === 'string' ? JSON.parse(val) : val;
            // 2. 如果是数组，提取 name 拼接
            if (Array.isArray(data)) {
                return data.map(item => item.name).filter(n => n).join(' / ') || '-';
            }
            // 3. 如果是对象，提取 name
            if (data && data.name) {
                return data.name;
            }
            return '-';
        },
        handleWhetherReleaseChange(val) {
            // 如果选择“是”(1)，则清空申请解控时间
            if (val === 1) {
                this.formData.releaseControlTime = '';
            }
        },
        lookFile(row) {
            this.lookFileConfig.filePaths = row.attachment
            this.lookFileVisible = true
        },
        

        lookDetail(row) {
            console.log(row)
            this.historyDetailForm = row
            this.files2 = this.historyDetailForm.attachment ? JSON.parse(this.historyDetailForm.attachment) : []
            // 获取所有节点
            let params = {
                processManagerId: row.processManagerId,
                processTaskId: row.processTaskId,
                processVersionId: row.processVersionId
            }
            getNodeList(params).then(res => {
                if (res.code === 1001) {
                    const newData = [];
                    res.data.forEach(item => {
                        const data = {
                            nodeName: item.nodeName,
                            userName: item.instanceLogsList.map(sItem => sItem.userName),
                            userId: item.instanceLogsList.map(sItem => sItem.userId),
                            multiApprovalType: item.multiApprovalType,
                            approvalOptions: item.instanceLogsList.map(sItem => sItem.approvalOptions),
                            handlerTime: item.instanceLogsList.map(sItem => sItem.handlerTime),
                            id: item.id,
                            approvalStatus: item.approvalStatus,
                            processInstanceId: item.processInstanceId,
                            processInstanceNodeId: item.instanceLogsList.map(sItem => sItem.processInstanceNodeId),
                        }
                        newData.push(data);
                    });
                    this.approveTableData = newData;

                }
            });
            this.historyDetailDig = true
        },
        saveRemoveControl() {
            console.log("-----------------this.formData----------------")
            console.log(this.formData)
            if (this.formData.whetherReleaseControl === '' || this.formData.whetherReleaseControl === null || this.formData.whetherReleaseControl === undefined) {
                this.$message.warning('请选择是否完全解控');
                return;
            }
            // 逻辑：只有当选择“否”(0) 时，该字段才显示且必填
            if (this.formData.whetherReleaseControl == 0) {
                if (this.formData.releaseControlTime == null|| this.formData.releaseControlTime== '') {
                    this.$message.warning('请选择申请解控时间');
                    return;
                }
            }
            if(this.formData.remark == null || this.formData.remark== '') {
                this.$message.warning('请输入未及时处理原因说明');
                return;
            }
            this.formData.newWhetherReleaseControl = this.formData.whetherReleaseControl
            this.formData.newReleaseControlTime = this.formData.releaseControlTime
            this.formData.attachment = JSON.stringify(this.files);
            this.$router.push({
                name: "superGraphCalculationApproval",
                query: {
                    formData: JSON.stringify(this.formData),
                    dataContent: JSON.stringify(this.formData),
                    type: 1,
                }
            })
        },
        uplodeSuccess(data) {
            const params = {
                fileName: data.fileName,
                filePath: data.fileUrl,
            };
            this.files.push(params);
            this.formData.attachment = JSON.stringify(this.files);
        },
        deleteFile(index) {
            this.files.splice(index, 1);
            this.formData.attachment = JSON.stringify(this.files);
        },
        gettableData() {
            superGraphQuery(this.tableParam).then(res => {
                if (res.code == 1001) {
                    this.total = res.data.totalRows
                    this.tableData = res.data.data
                    //第一次进入页面获取最近一个月的数据 回显筛选
                    if (!this.tableParam.dataMouth && res.data.data && res.data.data.length >0) {
                        this.tableParam.dataMouth = res.data.data[0].dataMouth
                    }
                }
            })
        },
        //type 为1 只展示历史
        applyRemoveControl(row) {
            if (row.nodeControlStatus == 3) {
                this.$message.warning('完全解控状态无需操作!')
                return
            }
            console.log('row', row)
            const initialFormData = this.$options.data().formData;
            querySuperGraphHistory({planId: row.planId }).then(res => {
                if (res.code == 1001) {
                    this.removeControlTableData = res.data || [];
                    this.low = JSON.parse(JSON.stringify(row));
                    this.formData = {
                        ...initialFormData,
                        ...this.low
                    };
                    this.formData.overDrawId = this.low.id;
                    if (this.formData.attachment) {
                        this.files = JSON.parse(this.formData.attachment);
                    } else {
                        this.files = [];
                    }
                    this.removeControlDig = true;
                    console.log('Final formData:', this.formData);
                }
            })
        },
        getSuperGraphHistory(row) {
            querySuperGraphHistory({ planId: row.planId }).then(res => {
                if (res.code == 1001) {
                    this.formData = JSON.parse(JSON.stringify(row))
                    this.low = JSON.parse(JSON.stringify(row))
                    this.removeControlTableData = res.data
                    this.historyDig = true
                }
            })
        },
        sizeChange(value) {
            this.tableParam.pageSize = value;
            this.gettableData();
        },
        /*重置数据,此方法必须存在，并且方发只重置条件*/
        init() {
            this.tableParam = this.$options.data().tableParam
            this.gettableData();
        },
    },
};
</script>
  
<style lang="scss" scoped>
.el-input,
.el-select {
    width: 240px;
}

.table_link {
    margin: 0 10px;
    color: $bg_color;
    cursor: pointer;
}

.table_link:hover {
    opacity: 0.8;
}

.textCss {
    display: flex;
    /* 核心1：开启Flex */
    align-items: center;
    text-align: center;
    /* 核心属性 */
}
</style>
<style scoped>
.descriptions>>>.redFont {
    color: red !important;
}

.descriptions>>>.textClass {
    width: 450px;
}

.descriptions>>>.textClass2 {
    width: 300px;
}
</style>